import React, { useEffect, useState } from 'react';
import UploadMultiDocuments from '@components/UploadMultiDocuments';
import { FileListData } from '@typings/ResidentTypes';
import UploadedFileTable from '@components/UploadedFileTable';
import { AboutMeTypes, AboutMeTypesFromData } from '../StepThreeTypes';

interface MultimediaFileProps {
  userId: string;
  aboutMe: AboutMeTypes;
  setAboutMe: (aboutMe: AboutMeTypes) => void;
  aboutMeFromData: AboutMeTypesFromData;
}

const MultimediaFile: React.FC<MultimediaFileProps> = ({
  userId,
  aboutMe,
  setAboutMe,
  aboutMeFromData,
}) => {
  const [locationMutimediaFiles, setLocationMutimediaFiles] = useState<
    FileListData[]
  >([]);

  // Update aboutMe when a new file is uploaded
  useEffect(
    () => {
      setAboutMe({ ...aboutMe, multimediaFiles: locationMutimediaFiles });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [locationMutimediaFiles]
  );

  useEffect(() => {
    setLocationMutimediaFiles(aboutMeFromData.multimediaFiles);
  }, [aboutMeFromData]);

  return (
    <div className="mt-10 govuk-bp:mt-14">
      <h1 className="govuk-heading-l">Location to multimedia file</h1>
      <div className="govuk-body">
        When a recording was made (audio or video) it can be uploaded below.
        Once uploaded this can be used for instant access.
      </div>
      <div className="govuk-body">
        We recommend that a copy of all recordings are also stored locally
        within your organisations records. We may not keep and store this file
        for longer than 24 months.
      </div>

      <UploadMultiDocuments
        userId={userId}
        fileList={locationMutimediaFiles}
        setFileList={setLocationMutimediaFiles}
        uploadInputId="upload-multimedia-file"
        customizedButtonText="Choose file"
        type="localMediaFile"
      />

      {locationMutimediaFiles?.length > 0 && (
        <div className="mt-10">
          <UploadedFileTable
            fileList={locationMutimediaFiles}
            setFileList={setLocationMutimediaFiles}
          />
        </div>
      )}
    </div>
  );
};

export default MultimediaFile;
